import React from 'react';
import { Form, Input, Button,Spin,Select } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var userlicence=''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;



const { Option } = Select;

class MineralLicenceCategoryUpdateForm extends React.Component {

  state = {
    licence:'' ,  
    purpose:'',
    datarequested:true,
    period:'',
    remarks:'',
    licence_type:'',

    jurisdiction:'',
    jurisdictions:[],

    spartial_shape_border_color:'',
    spartial_shape_background_color:'',
    maximum_area_for_spartial_shape:0


  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    const category_ID=this.props.category_ID;
    axios.get(`${serverconfig.backendserverurl}/api/mineral_licence_categories/${category_ID}`)
    .then(res => {  

        this.setState({licence:res.data.licence})
        this.setState({purpose:res.data.purpose})
        this.setState({period:res.data.period})
        this.setState({remarks:res.data.remarks})
        this.setState({licence_type:res.data.licence_type})
        this.setState({jurisdiction:res.data.jurisdiction})

        this.setState({spartial_shape_border_color:res.data.spartial_shape_border_color})
        this.setState({spartial_shape_background_color:res.data.spartial_shape_background_color})



        this.setState({maximum_area_for_spartial_shape:res.data.maximum_area_for_spartial_shape})


      //  this.setState({datarequested:false})
    })


    axios.get(serverconfig.backendserverurl+`/api/jurisdictions/`)
    .then(res => {
        this.setState({
          jurisdictions:res.data
        })
          this.setState({datarequested:false})
      })


  }



  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{
      return (
        <div>
    <Form
        
    >
      <FormItem label="licence"
       
      >
        <Input licence="licence"  placeholder="licence." value={this.state.licence} onChange={(val)=>{this.setState({licence:val.target.value})}} />
      </FormItem>


      <FormItem label="Purpose">
        <TextArea
            placeholder="Purpose"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.purpose}
            onChange={(val)=>{this.setState({purpose:val.target.value})}}
          />
        
      </FormItem>


      <FormItem label="Period (Months)">
            <Input
            placeholder="Period"
            value={this.state.period}
            onChange={(val)=>{this.setState({period:val.target.value})}}
          />
        
      </FormItem>


      <FormItem label="Remarks">
        <TextArea
            placeholder="Remarks"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.remarks}
            onChange={(val)=>{this.setState({remarks:val.target.value})}}
          />
        
      </FormItem>


      <FormItem label="Type Group">
          <Select 
          placeholder="licence_type" 
          style={{  }} 
          value={this.state.licence_type}
          onChange={(val)=>{
            this.setState({licence_type:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
          <Option value={"Spartial"}>{'Spartial'}</Option>
          <Option value={"NonSpartial"}>{'NonSpartial'}</Option>
          </Select>
      </FormItem>
     

      <FormItem label="Jurisdiction"
         
        >
            <Select 
            placeholder="Jurisdiction" 
            style={{  }} 
            value={this.state.jurisdiction}
            onChange={(val)=>{
              this.setState({jurisdiction:val})
            }} 
            showSearch
            optionFilterProp="children"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}   
            >
              {this.state.jurisdictions.map(
                (itm)=>(
                  <Option value={itm.id}>{itm.name}</Option>
                ))}
            </Select>
        </FormItem>



        <FormItem label="Maximum_area_for_spartial_shape (KM2)">
            <Input
            placeholder="maximum_area_for_spartial_shape"
            value={this.state.maximum_area_for_spartial_shape}
            type='number'
            onChange={(val)=>{this.setState({maximum_area_for_spartial_shape:val.target.value})}}
          />
        
      </FormItem>



      <FormItem label="Spartial_shape_border_color"
       
        >
            <Select 
            placeholder="Spartial_shape_border_color" 
            style={{  }} 
            value={this.state.spartial_shape_border_color}
            onChange={(val)=>{
              this.setState({spartial_shape_border_color:val})
            }} 
            showSearch
            optionFilterProp="children"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}   
            >
                 <Option value={'green'}>{'green'}</Option>
                 <Option value={'lightgreen'}>{'lightgreen'}</Option>

                 <Option value={'blue'}>{'blue'}</Option>
                 <Option value={'lightblue'}>{'lightblue'}</Option>

                 <Option value={'red'}>{'red'}</Option>
                 <Option value={'orange'}>{'orange'}</Option>
                 </Select>
        </FormItem>


        <FormItem label="Spartial_shape_background_color">
             <Select 
             placeholder="Spartial_shape_background_color" 
             style={{  }} 
             value={this.state.spartial_shape_background_color}
             onChange={(val)=>{
               this.setState({spartial_shape_background_color:val})
             }} 
             showSearch
             optionFilterProp="children"
             onFocus={this.onFocus}
             onBlur={this.onBlur}
             onSearch={this.onSearch}   
             >
                 <Option value={'green'}>{'green'}</Option>
                 <Option value={'lightgreen'}>{'lightgreen'}</Option>

                 <Option value={'blue'}>{'blue'}</Option>
                 <Option value={'lightblue'}>{'lightblue'}</Option>

                 <Option value={'red'}>{'red'}</Option>
                 <Option value={'orange'}>{'orange'}</Option>

             </Select>
         </FormItem>



      <FormItem>
        <Button  type="primary" htmlType="button" 
            onClick={()=>{

            var category_ID=this.props.category_ID
            this.setState({datarequested:true})

            let form_data = new FormData();
            form_data.append('licence', this.state.licence);
            form_data.append('purpose', this.state.purpose);
            form_data.append('period', this.state.period);
            form_data.append('remarks', this.state.remarks);
            form_data.append('licence_type', this.state.licence_type);
            form_data.append('jurisdiction', this.state.jurisdiction);

            form_data.append('spartial_shape_border_color', this.state.spartial_shape_border_color);
            form_data.append('spartial_shape_background_color', this.state.spartial_shape_background_color);

            form_data.append('maximum_area_for_spartial_shape', this.state.maximum_area_for_spartial_shape);

            axios.put(serverconfig.backendserverurl+`/api/mineral_licence_categories/${category_ID}/`, form_data, {
              headers: {
                'content-type': 'multipart/form-data'
              }
            })
            .then(res => {
            this.setState({datarequested:false})
            this.component_reloaded()

            ///refesrh
            this.props.onRefresh()

            }    

            )
            .catch(error => console.log(error))


        }}>Update Licence Category</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default MineralLicenceCategoryUpdateForm;



